import { Form, FormQuestion } from '../types'

const FORM_ID = 'form_ava_estrategia'

function q(
  partial: Omit<FormQuestion, 'formId' | 'conditionalLogic' | 'isActive'> &
    Partial<Pick<FormQuestion, 'conditionalLogic' | 'isActive'>>,
): FormQuestion {
  return {
    formId: FORM_ID,
    isActive: true,
    conditionalLogic: {
      enabled: false,
      questionId: null,
      operator: 'igual',
      value: '',
    },
    ...partial,
  }
}

/**
 * Las seis preguntas del formulario predeterminado.
 * Son datos, no código: se pueden editar por completo desde el
 * constructor de formularios sin tocar este archivo.
 */
export const AVA_QUESTIONS: FormQuestion[] = [
  q({
    id: 'q_ubicacion',
    label: '¿Dónde se encuentra tu negocio?',
    description: 'Indica la ciudad y el país.',
    type: 'texto_corto',
    required: true,
    order: 1,
    placeholder: 'Ejemplo: Madrid, España',
    options: [],
    crmField: 'city',
  }),
  q({
    id: 'q_instagram',
    label: '¿Cuál es el perfil principal de Instagram de tu empresa?',
    type: 'texto_corto',
    required: false,
    order: 2,
    placeholder: 'Ejemplo: @empresaoficial',
    options: [],
    crmField: 'instagram',
  }),
  q({
    id: 'q_descripcion',
    label: 'Describe brevemente a qué se dedica tu empresa.',
    description:
      'Cuéntanos qué productos o servicios ofreces y a qué tipo de cliente te diriges.',
    type: 'texto_largo',
    required: true,
    order: 3,
    placeholder:
      'Ejemplo: Somos una consultora inmobiliaria especializada en vivienda de obra nueva en Madrid…',
    options: [],
  }),
  q({
    id: 'q_tipo_servicio',
    label: '¿Cómo prefieres trabajar con nosotros?',
    description: 'Elige la modalidad que mejor encaje con tu empresa.',
    type: 'seleccion_unica',
    required: true,
    order: 4,
    options: ['Formación AVA', 'Gestión AVA Completa'],
    optionDescriptions: [
      'Aprender yo o mi equipo a crear contenido y sistemas de captación.',
      'Quiero que el equipo AVA lo gestione todo por mí.',
    ],
    crmField: 'service',
    crmValues: ['Formación AVA', 'Gestión AVA Completa'],
  }),
  q({
    id: 'q_inversion',
    label: '¿Actualmente inviertes en publicidad?',
    description: 'Indica aproximadamente cuánto destinas cada mes.',
    type: 'seleccion_unica',
    required: true,
    order: 5,
    options: [
      'No',
      'Menos de 500 €',
      '500 €',
      '1.000 €',
      '2.000 €',
      '3.000 € o más',
    ],
    crmField: 'adBudget',
  }),
  q({
    id: 'q_presupuesto',
    label:
      'Si la estrategia funciona y genera resultados, ¿con qué presupuesto mensual contarías para seguir escalando tu negocio?',
    type: 'seleccion_unica',
    required: true,
    order: 6,
    options: ['1.000 €', '2.000 €', '3.000 € o más'],
    crmField: 'budget',
  }),
]

/**
 * Formulario predeterminado que recibe cada organización nueva.
 * Empieza por el bloque de datos de contacto y continúa con las seis
 * preguntas, una por pantalla.
 */
export const AVA_FORM: Form = {
  id: FORM_ID,
  organizationId: 'org_ava',
  name: 'Solicitud de estrategia AVA',
  description:
    'Cuéntanos cómo funciona tu empresa y te preparamos una estrategia de captación a medida.',
  slug: 'solicitud-estrategia',
  status: 'activo',
  submitLabel: 'ENVIAR MI SOLICITUD',
  successMessage: 'Hemos recibido tu solicitud.',
  thankYouSlug: 'sistema-ava',
  contactPosition: 'inicio',
  contactTitle: 'Empecemos por tu información de contacto',
  contactFields: [
    {
      key: 'firstName',
      label: 'Nombre completo',
      type: 'texto_corto',
      required: true,
      placeholder: 'Ejemplo: Carlos Martínez',
    },
    {
      key: 'company',
      label: 'Nombre de la empresa o servicio',
      type: 'texto_corto',
      required: true,
      placeholder: 'Ejemplo: Grupo Empresarial XYZ',
    },
    {
      key: 'phone',
      label: 'Teléfono',
      type: 'telefono',
      required: true,
      placeholder: '600 123 456',
    },
    {
      key: 'email',
      label: 'Correo electrónico',
      type: 'email',
      required: true,
      placeholder: 'contacto@empresa.com',
    },
  ],
  // Aviso informativo, no bloqueante y ocultable. Sustituye a la antigua
  // casilla obligatoria de consentimiento.
  privacyNotice: {
    enabled: true,
    text: 'Al enviar este formulario aceptas que utilicemos tus datos para responder a tu solicitud.',
    linkLabel: 'Consulta nuestra política de privacidad.',
  },
  consentText: '',
  questions: AVA_QUESTIONS,
  createdAt: '2026-05-02T09:00:00.000Z',
  updatedAt: '2026-08-02T11:30:00.000Z',
}
